module.exports = __webpack_public_path__ + "static/media/maglondon.dcffc808.png";